import styled from 'styled-components';

export const TableWrapperStyle = styled.div`
  color: #525f7f;
  font-weight: 600;
  margin-top: 20px;

  .multi-line {
    white-space: pre-wrap;
    line-height: 1.5;
    text-align: center;
  }
`;

export const TableTitleStyle = styled.h2`
  font-size: 20px;
  margin-bottom: 20px;
`;
